import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, HostListener, NgZone } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LayersService } from '../_services/layers.service';
import { TabledataService } from '../_services/tabledata.service';
import { EventsService } from '../_services/events.service';
import { KeycloakService } from '../login/keycloak.service';
import { LoginService } from '../login/login.service';
import { SearchService } from '../search/search.service';
import { Mapapi } from '../ol-map/mapapi';
import { ReportsService } from '../reports/reports.service';
import { MessageService } from 'primeng/api';
import { ExportService } from '../_services/export.service';

declare var $: any;
@Component({
    selector: 'app-map-view',
    templateUrl: './map-view.component.html',
    styleUrls: ['./map-view.component.css'],
    standalone: false
})
export class MapViewComponent implements OnInit {
    treeVisible: boolean = true;
    treeWidthPx: number = 350;
    tableshidden: boolean = false;
    countvisible: number = 0;
    legendhidden: boolean = false;
    treehidden: boolean = false;
    showLegendButton: boolean = false;
    showTreeButton: boolean = false;
    isSuperuser: boolean = false;
    midparameter: number;
    obimeparameter: string;
    reportvisible: boolean;
    locinfsid: number = null;
    isGeneratingReport: boolean = false;

    constructor(private api: Mapapi, private keycloak: KeycloakService, private route: ActivatedRoute,
        private ls: LayersService, private tableService: TabledataService, private es: EventsService,
        private los: LoginService, private rs: ReportsService, private ss: SearchService,
        private messageService: MessageService, private ngZone: NgZone,
        private exportService: ExportService) {
        this.reportvisible = !los.isPublic();
    }

    public showMenu(): void {
        this.treeVisible = !this.treeVisible;
    }

    onHChangeResize(event): void {

        this.es.sendDomResizeEvt(event);
        this.api.resizeMap();

    }

    ngAfterViewInit() {
        this.legendhidden = true;
        this.tableshidden = true;
    }

    onVChangeResize(event): void {
        this.api.resizeMap();
    }

    logoff(): void {
        this.keycloak.logout();
    }


    public startTreeResize(event: MouseEvent): void {
        const startX = event.clientX;
        const startWidth = this.treeWidthPx;
        const onMove = (e: MouseEvent) => {
            const w = Math.max(150, Math.min(600, startWidth + (e.clientX - startX)));
            this.ngZone.run(() => { this.treeWidthPx = w; });
        };
        const onUp = () => {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
        };
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        event.preventDefault();
    }

    public setHiddenLegend(v: boolean) {
        this.es.setVisibleLegendsEvt(v);
        this.afterLayoutChangeResizeMap();
    }

    public setHiddenTree(v: boolean) {
        this.es.setVisibleTreeEvt(v);
        this.afterLayoutChangeResizeMap();
    }

    private afterLayoutChangeResizeMap() {
    // Wait until the split layout + DOM have actually updated sizes
    requestAnimationFrame(() => {
            requestAnimationFrame(() => {
            this.api.resizeMap();
            });
        });
    }

    public onAnySplitChanged() {
        this.afterLayoutChangeResizeMap();
        requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    }

    public openReport() {
        if (this.isGeneratingReport) {
            return;
        }

        console.log("call open report !");
        this.rs.openReportComponent();
    }

    public openWikiReport() {
        this.messageService.add({ key: 'mapView', severity: 'info', summary: 'Obvestilo', detail: 'Poročilo v izdelavi prosimo počakajte ....' });
        this.rs.exportViriFile("pdf", "userLocale=de&reportLocale=de&ob_ime=" + this.obimeparameter.replace(new RegExp(" ", 'g'), "+") + "&ob_mid=" + this.midparameter + "&showreports=podatkovniViri", "podatkovniViri")
            .subscribe(d => {
                this.rs.downloadFile(d, "podatkovni_viri_" + this.obimeparameter + ".pdf", "pdf");
                this.messageService.add({ key: 'mapView', severity: 'info', summary: 'Obvestilo', detail: 'Poročilo izdelano ... ' });
            }, e => {
                this.messageService.add({ key: 'mapView', severity: 'error', summary: 'Obvestilo', detail: 'Napaka :' + e });
            }, () => { this.messageService.clear(); });
    }


    public openLokInfReport() {
        this.messageService.add({ key: 'mapView', severity: 'info', summary: 'Obvestilo', detail: 'Poročilo v izdelavi prosimo počakajte ....' });
        this.rs.exportFile("lokacijskaInformacija", "pdf", "userLocale=de&reportLocale=de&" + "sid=" + this.locinfsid + "&showreports=lokacijskaInformacija")
            .subscribe(d => {
                this.rs.downloadFile(d, "lokacijska_informacija" + this.obimeparameter + ".pdf", "pdf");
                this.messageService.add({ key: 'mapView', severity: 'info', summary: 'Obvestilo', detail: 'Poročilo izdelano ... ' });
            }, e => {
                this.messageService.add({ key: 'mapView', severity: 'error', summary: 'Obvestilo', detail: 'Napaka :' + e });
            }, () => { this.messageService.clear(); });
    }

    ngOnInit() {
        this.isSuperuser = this.los.isAuthorisedRole("root");
        this.exportService.init();

        this.rs.subscribeGeneratingReportListener().subscribe(v => {
            this.isGeneratingReport = v;
        });

        this.ss.subscribeSelectedResultListener().subscribe(r => {
            console.log(r);
            this.locinfsid = r?._sta_sid ?? null;
        });

        this.ss.subscribeUnSelectedResultListener().subscribe(r => {
            this.locinfsid = null;
        });

        this.tableService.subscribeCountVisibleTableListener().subscribe(cnt => {
            this.tableshidden = (cnt === 0);
            this.afterLayoutChangeResizeMap();
        });

        this.es.subscribeVisibleTreeListener().subscribe(v => {
            this.showTreeButton = v;
            this.treehidden = v;
            this.afterLayoutChangeResizeMap();
        });

        this.es.subscribeCountVisibleLegendsListener().subscribe(cnt => {
            if (typeof cnt === 'boolean') {
                this.legendhidden = cnt;
                this.showLegendButton = cnt;
            } else {
                this.legendhidden = (cnt === 0);
                if (cnt === 0) this.showLegendButton = false;
            }
            this.afterLayoutChangeResizeMap();
        });

        this.ls.subscribeLayersGroupLoadListener().subscribe(
            data => {
                if (data.ob_mid !== undefined) {
                    this.midparameter = data.ob_mid;
                    this.obimeparameter = data.ob_uime;
                    this.exportService.setMid(data.ob_mid);
                } else {
                    console.log("load layer group error: data undefined ");
                }
            },
            err => { console.log(err) }
        );
    }

    mobileMenuVisible = false;

    openMobileMenu(): void {
        this.mobileMenuVisible = true;
    }

    closeMobileMenu(): void {
        this.mobileMenuVisible = false;
    }

    @HostListener('window:resize')
    onResize(): void {
        // če gre nazaj na desktop širino, zapri popup
        if (window.innerWidth > 900 && this.mobileMenuVisible) {
        this.mobileMenuVisible = false;
        }
    }

}
